<template>
  <vx-card no-shadow>

    <div class="mb-base">
      <h5 class="mb-4">Medios de Notificación</h5>

      <div class="flex items-center mb-4">
        <vs-switch v-model="sms" />
        <span class="ml-4">SMS</span>
      </div>
      <div class="flex items-center mb-4">
        <vs-switch v-model="email" />
        <span class="ml-4">Email</span>
      </div>
      <div class="flex items-center mb-4">
        <vs-switch v-model="webPush" />
        <span class="ml-4">Web Push</span>
      </div>

    </div>
    <div class="mb-base">
      <h6 class="mb-4">Consultas</h6>

      <div class="flex items-center mb-4">
        <vs-switch v-model="comment" />
        <span class="ml-4">Nueva Consulta</span>
      </div>
      <div class="flex items-center mb-4">
        <vs-switch v-model="answer" />
        <span class="ml-4">Consulta Cancelada</span>
      </div>
      <div class="flex items-center mb-4">
        <vs-switch v-model="follow" />
        <span class="ml-4">Consulta Reprogramada</span>
      </div>
    </div>

    <div>
      <h6 class="mb-4">General</h6>

      <div class="flex items-center mb-4">
        <vs-switch v-model="news" />
        <span class="ml-4">Cambio de Contraseña</span>
      </div>
      <div class="flex items-center mb-4">
        <vs-switch v-model="product_update" />
        <span class="ml-4">Actualización</span>
      </div>
      <div class="flex items-center">
        <vs-switch v-model="blog" />
        <span class="ml-4">Nuevo Paciente</span>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end mt-base">
      <vs-button class="ml-auto mt-2">Guardar Cambios</vs-button>
      <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
    </div>

  </vx-card>
</template>

<script>
export default {
  data () {
    return {
      sms: true,
      email: true,
      webPush: true,
      comment: true,
      answer: true,
      follow: false,
      news: false,
      product_update: false,
      blog: true
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  }
}
</script>
